/* eslint-disable */
export default {
  activeCall: 'Active Call',
} as const;

// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
